import { Tooltip, Typography } from "antd"
import { InvoiceSummary } from "../../../domain/invoicing/invoice"

const Text = Typography.Text

type Props = {
  invoiceSummary: InvoiceSummary
}

const InvoiceNumberDisplay = ({ invoiceSummary }: Props) => {
  if (invoiceSummary.invoicingSystem === 'synkedUp') {
    if (invoiceSummary.qboDisplayName) {
      return (
        <Tooltip title={`QuickBooks ${invoiceSummary.qboDisplayName}`}>
          <span>{invoiceSummary.invoiceNumber}</span>
        </Tooltip>
      )
    }
    return <>{invoiceSummary.invoiceNumber}</>
  }
  return <>{invoiceSummary.qboDisplayName || <Text type="secondary">(Not exported)</Text>}</>
}

export default InvoiceNumberDisplay
